// extracted by mini-css-extract-plugin
export default {"wrap":"eG-z","fullWidth":"fG-z","hideOnDesktop":"gG-z","content":"hG-z","hasOpenedNav":"iG-z","crumbsList":"jG-z","dropdownsWrap":"kG-z"};